import React from 'react';
import './SearchPanel.css';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';
import { classNames } from '../../functions/classNames';

const SearchPanel = (props, context) => (
  <div className={classNames('SearchPanel', props.error ? 'hasError' : '')} style={props.style}>
    <div className="inputLabel">
      <span>{getLabel(context.locale, props.label)}</span>
      {props.required ? <span className="required">*</span> : ''}
    </div>
    <input
      type="text"
      name={props.name}
      value={props.value}
      onChange={props.handleChange}
      placeholder={props.placeholder ? props.placeholder : ''}
      autoComplete="off"
      disabled={props.disabled}
      autoFocus={props.autoFocus}
    />
  </div>
);

SearchPanel.contextTypes = {
  locale: PropTypes.string,
};

export default SearchPanel;



// WEBPACK FOOTER //
// ./src/main/components/input/SearchPanel.js